import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

import { IconName } from '../../icons-container/icons.type';

export const IconSizes = {
  'small-xxx': 8,
  'small-xx': 12,
  'small-x': 16,
  small: 18,
  medium: 24,
  large: 32,
  'large-x': 48,
  'large-xx': 54,
};

export type IconSize = keyof typeof IconSizes;

export enum IconColor {
  Primary,
  Default,
  Light,
  Green,
  ContextAltDark,
  White,
  Yellow,
  ContextAlt,
  Darkest,
}

@Component({
  standalone: true,
  selector: 'rt-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.icon]': 'true',
    '[class.has-small-x-right-margin-in-tab]': 'hasSmallXRightMarginInTab',
    '[class.has-auto-height]': 'hasAutoHeight',
    '[class.is-light]': 'color === IconColor.Light',
    '[class.color-green]': 'color === IconColor.Green',
    '[class.color-primary]': 'color === IconColor.Primary',
    '[class.color-default]': 'color === IconColor.Default',
    '[class.color-white]': 'color === IconColor.White',
    '[class.color-yellow]': 'color === IconColor.Yellow',
    '[class.color-context-alt-dark]': 'color === IconColor.ContextAltDark',
    '[class.color-context-alt]': 'color === IconColor.ContextAlt',
    '[class.color-darkest]': 'color === IconColor.Darkest',
  },
})
export class IconComponent implements OnChanges {
  @Input() public name: IconName = 'information';
  @Input() public hasSmallXRightMarginInTab: boolean = false;
  @Input() public hasAutoHeight: boolean = false;
  @Input() public color: IconColor | undefined;

  /* @deprecated */
  @Input() public set isGreen(value: boolean) {
    this.color = value ? IconColor.Green : this.color ? this.color : undefined;
  }
  /* @deprecated */
  @Input() public set isLight(value: boolean) {
    this.color = value ? IconColor.Light : this.color ? this.color : undefined;
  }
  @Input()
  public set size(value: IconSize) {
    const size = IconSizes[value];
    if (!size) {
      throw new Error(`Invalid icon size [icon name: ${this.name}, size: ${value}]`);
    }
    this.sizeInPx = `${size}px`;
  }

  public IconColor = IconColor;

  public svgName: string = `#${this.name}`;
  public sizeInPx: string = `${IconSizes['small']}px`;

  constructor(private renderer: Renderer2, public elementRef: ElementRef) {}

  public ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges.name) {
      const { previousValue, currentValue } = simpleChanges.name;
      if (previousValue) {
        this.renderer.removeClass(this.elementRef.nativeElement, `icon--${previousValue}`);
      }
      this.renderer.addClass(this.elementRef.nativeElement, `icon--${currentValue}`);
      this.svgName = `#${currentValue}`;
    }
  }
}
